import { Button } from "shared/ui/button";

const items = [
  {
    title: "Deposit Stablecoins",
    description: "Mint bentoUSD to earn 30x Wasabi + other rewards.",
  },
  {
    title: "Earn Points Daily",
    description:
      "Earn Wasabi points daily on holding bentoUSD. Hold longer, earn more.",
  },
  {
    title: "Maximize Your Rewards",
    description:
      "Earn even more by using bentoUSD across DeFi protocols in the Bento ecosystem and participating in Bento’s referral program.",
  },
  {
    title: "Withdraw Anytime. No Lock-up.",
    description:
      "Withdraw instantly without any lock-up and keep all your earned rewards.",
  },
];

export const DetailsWasabiContent = () => {
  return (
    <div className="flex gap-5 px-6 py-9.5">
      <ul className="flex flex-col gap-7.5">
        {items.map((item, index) => {
          return (
            <li key={item.title} className="relative flex flex-col pl-7.5">
              <span className="absolute top-0 left-0 inline-flex text-current">
                {index + 1}.
              </span>
              <h4 className="leading-none text-white">{item.title}</h4>
              <p className="text-nobel mt-2 leading-[150%] font-normal">
                {item.description}
              </p>
            </li>
          );
        })}
      </ul>

      <div className="flex flex-col text-current">
        <div
          style={{
            backgroundImage: `background: linear-gradient(0deg, rgba(15, 15, 15, 0.5), rgba(15, 15, 15, 0.5)), radial-gradient(83.45% 69.49% at 50% 104.38%, rgba(34, 237, 78, 0.1) 0%, rgba(34, 237, 78, 0) 100%)`,
          }}
          className="flex w-[363px] grow flex-col items-center justify-center rounded-[18px]"
        >
          HARDCODE
        </div>
        <Button className="mt-4 w-full" size="38" variant="current">
          <span className="text-onyx">Deposit +</span>
        </Button>
      </div>
    </div>
  );
};
